import React from "react";

const OlympiadPageContext = React.createContext();

export { OlympiadPageContext };
